
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import axiosClient from '../../../axios-client.js';
import btnClose from '../../assets/svg/btn/close.svg';
import icPassword from '../../assets/svg/modal/ic-password.svg';
import icBtnPassword from '../../assets/svg/btn/reset-password.svg';

const ForgotPassword = ({ show, handleClose }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    
    const payload = {
      email: email,
    };

    axiosClient.post('/password/email?', payload)
      .then(({ data }) => {
        setLoading(false);
        setMessage({ message: data.message });
      })
      .catch((error) => {
        setLoading(false);
        const response = error.response ? error.response.data : { message: 'An error occurred' };
        setMessage(response);
      });
  };

  return (
    <Modal centered className='modal-lg' show={show} onHide={handleClose}>
      <Modal.Header className='border-0 d-flex flex-row-reverse bd-highlight'>
        <Button className='rounded-circle btn-gray' variant='none' onClick={handleClose}>
          <img src={btnClose} alt='' />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className='container-fluid text-center'>
          <img className='ic-modal-password' src={icPassword} alt='' />
          <h3 className='text-center title my-3'>Reset Password</h3>
        </div>
        <div className='row justify-content-center align-items-center'>
          <form className='my-5 col-md-8' onSubmit={handleSubmit}>
            <label className='my-3 p-1' htmlFor='email'>Email Address</label>
            <input
              className='form-control col-md-12 rounded-25'
              placeholder='your@email.com'
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div className='d-flex justify-content-start align-items-center'>
              <img className='ic-password-resset' src={ icBtnPassword } alt='Reset Password' />
              <button type='submit' disabled={loading} className='text-center mt-4 bg-btn-blue btn-primary mb-3'>
                {loading ? 'Sending...' : 'Send Request'}
              </button>
            </div>
            {message && (
              <p className={`alert ${message.errors ? 'alert-danger' : 'alert-success'}`} role="alert">
                {message.errors ? message.errors.email[0] : message.message}
              </p>
            )}
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ForgotPassword;